import React from 'react';

/**
 * Drawer component for mobile navigation (off-canvas)
 * Manages sidebar visibility on small screens
 */
function Drawer({ isOpen, onClose, children }) {
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleEscape = (e) => {
    if (e.key === 'Escape') onClose();
  };

  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onClose]);

  return (
    <>
      {/* Overlay */}
      <div
        className={`ag-overlay ${isOpen ? 'active' : ''}`}
        onClick={onClose}
        role="presentation"
        aria-hidden={!isOpen}
      />
      {/* Drawer content */}
      <aside
        className={`ag-home-sidebar ${isOpen ? 'active' : ''}`}
        role="navigation"
        aria-label="Mobile navigation menu"
        aria-hidden={!isOpen}
      >
        <button
          className="ag-drawer-close"
          onClick={onClose}
          aria-label="Close navigation menu"
          type="button"
        >
          ✕
        </button>
        {children}
      </aside>
    </>
  );
}

export default Drawer;
